// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".assessment-status{display:inline-block}.assessment-status__text--started{color:var(--color-action-blue)}", ""]);
// Exports
module.exports = exports;
